<template lang="pug">
Auth(@loginFailed="onFailedAuthentication")
  Header(:content="headerContent")
  ModalPage(
    ref="modalPage"
    v-if="uid",
    @closeModalPage="closeModalPage",
    :modalPageContentId="modalPageContentId",
    :showModal="showModalPage"
  )
  ModalWindow(
    @closeModal="closeModalWindow",
    modalContentId="tmp",
    :showModal="showModalWindow"
  )
  div.wrap-trainer-calendar.f.fh
    ModuleCalendar
    //- div
      p(@click="$router.push('/home/id')") to modal page
      p(@click="logout") Sign Out
</template>

<style lang="scss" scoped>
.wrap-trainer-calendar {
  width: 100%;
  min-height: 100vh;
}
</style>

<script>
import { env } from "@/components/utils/firebase"
import { createNamespacedHelpers } from 'vuex'
import Auth from '@/components/auth'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import Header from '@/components/shared/Header.vue'
import ModalWindow from '@/components/shared/ModalWindow.vue'
import ModalPage from '@/components/shared/ModalPage.vue'
import ModuleCalendar from '@/components/module/ModuleCalendar'

export default {
  components: {
    Auth,
    Header,
    ModalWindow,
    ModalPage,
    ModuleCalendar
  },
  computed: {
    ...mapStateAuth(['uid']),
    env: function () {
      return env
    }
  },
  data () {
    return  {
      modalPageContentId: "",
      showModalPage: false,
      showModalWindow: false,
      headerContent: {},
      rootHeaderContent: {
        label: 'カレンダー',
        leftAction: {
          icon: 'event',
          color: (env.indexOf('asc') > -1) ? "#45bad5" : "#0099d7",
          method: () => {
            this.$router.push("/trainer/calendar")
          }
        },
        rightAction: {
          icon: 'account_circle',
          color: (env.indexOf('asc') > -1) ? "#45bad5" : "#0099d7",
          method: () => {
            this.$router.push(`/trainer/${this.uid}`)
          }
        }
      }
    }
  },
  created () {
    this.headerContent = this.rootHeaderContent
    this.routeModalPage()
  },
  watch: {
    '$route': function (to, from) {
      this.routeModalPage()
    }
  },
  methods: {
    ...mapActionsAuth(["signOut"]),
    logout () {
      this.signOut()
      setTimeout(() => {
        this.$router.push("/trainer/sign-in")
      }, 400)
    },
    onFailedAuthentication () {
      this.$router.push("/trainer/sign-in")
    },
    onHeaderRight () {
      console.log("on right")
    },
    closeModalPage () {
      this.showModalPage = false
    },
    closeModalWindow () {
      this.showModalWindow = false
    },
    async routeModalPage () {
      this.headerContent = {}
      console.log("name:", this.$route.name)
      if (this.$route.name === "trainer-detail-event") {
        this.showModalPage = true
        this.modalPageContentId = "detail_event"
        this.headerContent = {
          label: "イベント",
          leftAction: {
            icon: "navigate_before",
            method: () => {
              this.$router.push("/trainer/calendar")
            }
          },
          rightAction: {
            label: "編集",
            color: "#1967d2",
            method: () => {
              this.$router.push(`/trainer/calendar/${this.$route.params.eventId}/edit`)
            }
          }
        }
      } else if (this.$route.name === "edit-event") {
        this.showModalPage = true
        this.modalPageContentId = "edit_event"
        this.headerContent = {
          label: "イベントを編集",
          leftAction: {
            icon: "navigate_before",
            method: () => {
              this.$router.push("/trainer/calendar")
            }
          },
          rightAction: {
            label: "保存",
            color: "#1967d2",
            method: this.saveEvent              
          }
        }
      } else {
        this.showModalPage = false
        this.modalPageContentId = ""
        this.headerContent = this.rootHeaderContent
      }
    },
    async saveEvent () {
      var editEventModule = this.$refs.modalPage.$refs.editEvent
      await editEventModule.saveEvent()
      // this.$router.push("/trainer/calendar")
    }
  }
}
</script>
